const TOKEN_KEY = "nycf_api_token";

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export const ADMIN_ROLES = new Set(["td", "admin", "super_admin"]);

export function isAdminRole(role: string): boolean {
  return ADMIN_ROLES.has(role);
}
